import { render, staticRenderFns } from "./MpShare.vue?vue&type=template&id=446b4241&scoped=true&"
import script from "./MpShare.vue?vue&type=script&lang=js&"
export * from "./MpShare.vue?vue&type=script&lang=js&"
import style0 from "./MpShare.vue?vue&type=style&index=0&id=446b4241&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b4241",
  null
  
)

export default component.exports